import { gql } from '@apollo/client';

export const NIGHTLY_COUNT_FRAGMENT = gql`
  fragment NightlyCount on NightlyCountOutput {
    id
    officeId
    office {
      id
      name
      regionName
    }
    countDate
    createdByUserId
    createdByUser {
      id
      firstName
      lastName
      email
    }
    lastEditedByUserId
    lastEditedByUser {
      id
      firstName
      lastName
      email
    }
    lastEditedAt
    createdAt
    updatedAt
    items {
      id
      productKey
      productTitle
      woocommerceProductId
      productClass
      productBloodType
      count
    }
  }
`;

export const GET_NIGHTLY_COUNT_FOR_TODAY_QUERY = gql`
  query getNightlyCountForToday($input: GetNightlyCountForTodayInput!) {
    getNightlyCountForToday(input: $input) {
      ...NightlyCount
    }
  }
  ${NIGHTLY_COUNT_FRAGMENT}
`;

export const GET_NIGHTLY_COUNTS_LIST_QUERY = gql`
  query getNightlyCountsList($input: GetNightlyCountsListInput!) {
    getNightlyCountsList(input: $input) {
      data {
        ...NightlyCount
      }
      meta {
        total
      }
    }
  }
  ${NIGHTLY_COUNT_FRAGMENT}
`;

export const GET_NIGHTLY_COUNT_OFFICES_QUERY = gql`
  query getNightlyCountOfficesForCurrentUser {
    getNightlyCountOfficesForCurrentUser {
      id
      name
      regionName
    }
  }
`;
